<div class="refer-a-friend">
  <div class="vm-row">
    <div class="vm-col-xs-12 vm-col-sm-6 vm-col-lg-6">
      <div class="refer-a-friend-img">
        <img [src]="imageUrl" alt="refer a friend image" />
      </div>
    </div>
    <div class="vm-col-xs-12 vm-col-sm-6 vm-col-lg-4 align-self-center">
      <div class="refer-a-friend-container">
        <span class="refer-a-friend-header">{{ optionHeader }}</span>
        <div class="refer-a-friend-subheader">{{ optionSubHeader }}</div>
        <div class="vm-row">
          <div class="vm-col vm-col-12">
            <vm-button
              [level]="ButtonLevel.PRIMARY"
              [type]="ButtonType.LINK"
              [href]="buttonLink"
              [target]="buttonTarget">
              {{ buttonText }}
            </vm-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
